import { cn } from "@newxsystems/shared";
import { GroundCardLink } from "../../../../modules/content/components/GroundCardLink/GroundCardLink";
import { GroundCommonContent } from "../../../../modules/content/components/GroundCommonContent/GroundCommonContent";
import { GroundMedia } from "../../../../modules/content/components/GroundMedia/GroundMedia";
import { GroundRichText } from "../../../../modules/content/components/GroundRichText/GroundRichText";
import { GroundSection } from "../../../../modules/content/components/GroundSection/GroundSection";
import type { ITestimonialGridBlockProps } from "./TestimonialGridBlock.props";

const columns = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
} as const;
const spans = {
  1: "lg:col-span-1",
  2: "lg:col-span-2",
  3: "lg:col-span-3",
  4: "lg:col-span-4",
} as const;

export const TestimonialGridBlock = ({
  alignment,
  anchorId,
  buttons,
  columnCount,
  description,
  eyebrow,
  heading,
  items,
  parentClass,
  spacing,
}: ITestimonialGridBlockProps) => {
  if (!items?.length) return null;

  return (
    <GroundSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-10 md:gap-14">
        <GroundCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div className={cn("grid grid-cols-1 sm:grid-cols-2", columns[columnCount || 3])}>
          {items.map((item, index) => (
            <GroundCardLink
              className={cn(
                "flex flex-col justify-between border-b border-r border-weathered-steel bg-charcoal-green-ink p-7 text-mineral-gray first:border-l",
                spans[item.columnSpan || 1],
              )}
              key={index}
              link={item.cardLink}
            >
              <blockquote>
                <GroundRichText
                  className="font-ground-body text-2xl leading-snug text-mineral-gray md:text-3xl"
                  content={item.quote}
                />
              </blockquote>
              <div className="mt-10 flex items-center gap-4">
                {item.portrait ? (
                  <GroundMedia
                    aspectRatio="1:1"
                    className="size-14 shrink-0"
                    media={item.portrait.image}
                    sizes="56px"
                  />
                ) : null}
                <div>
                  <p className="font-ground-mono text-sm font-medium">{item.name}</p>
                  {item.attribution ? (
                    <p className="mt-1 font-ground-mono text-xs text-mineral-gray/75">
                      {item.attribution}
                    </p>
                  ) : null}
                </div>
              </div>
            </GroundCardLink>
          ))}
        </div>
      </div>
    </GroundSection>
  );
};

TestimonialGridBlock.displayName = "Block::TestimonialGridBlock";
